import MainMenuConfig from '@/core/config/MainMenuConfig';

// Menü yapılandırmasından { route → permission } düz haritası (bir kez kurulur)
let routePermMap = null;

function buildMap(items, acc) {
    for (const it of items || []) {
        if (it.route && it.permission) acc[it.route] = it.permission;
        if (Array.isArray(it.sub)) buildMap(it.sub, acc);
        if (Array.isArray(it.pages)) buildMap(it.pages, acc);
    }
    return acc;
}

function getMap() {
    if (!routePermMap) routePermMap = buildMap(MainMenuConfig, {});
    return routePermMap;
}

// Hedef yol için en uzun (en özgül) eşleşen menü route'unun iznini bul.
// Alt sayfalar (ör. .../slider/group/5) üst route'un iznini paylaşır.
function permissionFor(path) {
    const map = getMap();
    let perm = null, best = -1;
    for (const route in map) {
        if (path === route || path.startsWith(route + '/')) {
            if (route.length > best) { best = route.length; perm = map[route]; }
        }
    }
    return perm;
}

// Yetkisiz sayfalara erişimi engelle (auth middleware'inden sonra çalışır).
// permission/canPath "fail open" olduğundan izinler yüklenmeden / tam erişimde engellemez.
export default function permission({to, next, store, nextMiddleWare}) {
    const perm = permissionFor(to.path);

    if (perm && !store.getters['permission/canPath'](perm)) {
        return next({name: 'dashboard'});
    }

    if (nextMiddleWare) return nextMiddleWare();
    return next();
}
